module.exports = __webpack_public_path__ + "static/khitbah-7b931924cbf96c494701ad4c2da0a787.jpg";